:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._container_vg0eo_7 {
  display: flex;
  width: 100%;
  height: 24px;
  justify-content: center;
  --bg-color: transparent;
  background: var(--bg-color);
  cursor: pointer; }
  ._container_vg0eo_7 ._icon_vg0eo_15 {
    fill: var(--elements-color); }
  ._container_vg0eo_7._disabled_vg0eo_17 {
    cursor: default; }
    ._container_vg0eo_7._disabled_vg0eo_17 ._icon_vg0eo_15 {
      fill: #bcbcbc; }
  ._container_vg0eo_7._active_vg0eo_21 {
    --elements-color: #116dff; }

._legacy_vg0eo_24 {
  --elements-color: #000624; }
  ._legacy_vg0eo_24:hover {
    --elements-color: #116dff; }

._primary_vg0eo_29 {
  --elements-color: #ffffff; }
  ._primary_vg0eo_29:hover:not(._disabled_vg0eo_17) {
    --bg-color: #4b31dc; }

._secondary_vg0eo_34 {
  --elements-color: #6f56f9; }
  ._secondary_vg0eo_34:hover:not(._disabled_vg0eo_17) {
    --bg-color: #d9d2ff;
    --elements-color: #4b31dc; }

._legacySoap_vg0eo_40 {
  --elements-color: #000624; }
  ._legacySoap_vg0eo_40:hover {
    --elements-color: #116dff; }

._primarySoap_vg0eo_45 {
  --elements-color: #ffffff; }
  ._primarySoap_vg0eo_45:hover:not(._disabled_vg0eo_17) {
    --bg-color: #dd560e; }

._secondarySoap_vg0eo_50 {
  --elements-color: #fe620f; }
  ._secondarySoap_vg0eo_50:hover:not(._disabled_vg0eo_17) {
    --bg-color: #fee8dc; }

._tooltipCustomLink_vg0eo_55 {
  padding-top: 5px; }
